module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"candidates":"Кандидаты","tariffInactiveTitle":"Тариф закончился","tariffInactiveText":"Для получения доступа к функциям Вашего тарифа необходимо внести оплату.","tariffInactiveButton":"Оплатить тариф"}}')
  delete Component.options._Ctor
}
